import React, { useState } from 'react';
import Header from './components/Header';
import Background from './utils/background';
import Experience from './components/Experience';
import Projects from './components/Projects';
import AboutMe from './components/AboutMe';
import Hero from './components/Hero';
import Footer from './components/Footer';
import Contact from './components/Contact';
import LanguageSwitcher from './components/LanguageSwitcher';
import './App.css';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(true);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div className={isDarkMode ? 'dark' : 'light'}>
      <Header isDarkMode={isDarkMode} />
      <Background isDarkMode={isDarkMode} />
      <div className="content">
        <Hero isDarkMode={isDarkMode} onToggleDarkMode={toggleDarkMode} />
        <AboutMe isDarkMode={isDarkMode} onToggleDarkMode={toggleDarkMode} />
        <Projects isDarkMode={isDarkMode} />
        <Experience isDarkMode={isDarkMode} />
        <Contact isDarkMode={isDarkMode} />
      </div>
      <Footer isDarkMode={isDarkMode} />
      <LanguageSwitcher isDarkMode={isDarkMode} />
    </div>
  );
}

export default App;
